import React from 'react';
import { NavLink } from 'react-router-dom';
import {frontendUrl, host} from '../../utils/globals';

export default ({ img, title, date, file }) => {
    return (
        <li>
            <figure>
                <NavLink to="#">
                    <img src={img ? `${frontendUrl}${img}` : "/img/logo-blue.svg"} alt="" style={{ width: "107px", height: "75px", objectFit:"contain" }} />
                </NavLink>
            </figure>
            <div className="li-right">
                <p>
                    { file && file.length > 0 ? (
                        <a href={frontendUrl+file} target="_blank">{title}</a>
                    ) : (
                        <NavLink to="#">{title}</NavLink>
                    )}
                </p>
                <small>{date}</small>
            </div>
        </li>
    )
}
